import AdyenConfirmationRequest from 'src/adminPanel/entities/offsetting/adyenBatches/AdyenConfirmationRequest';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_ADYEN_BATCHES = 'FETCH_ADYEN_BATCHES';
export const REQUEST_ADYEN_BATCHES = 'REQUEST_ADYEN_BATCHES';
export const SUCCESS_ADYEN_BATCHES = 'SUCCESS_ADYEN_BATCHES';
export const FAILURE_ADYEN_BATCHES = 'FAIL_ADYEN_BATCHES';

export const fetchAdyenBatches = (
    pageable?: PageableQueryParams,
    batchNumber?: string | undefined,
    confirmedState?: boolean | undefined
) => action(FETCH_ADYEN_BATCHES, { pageable, batchNumber, confirmedState });
export const requestAdyenBatches = () => action(REQUEST_ADYEN_BATCHES);
export const requestAdyenBatchesSuccess = (response: any) => action(SUCCESS_ADYEN_BATCHES, { response });
export const requestAdyenBatchesFailure = (error: any) => action(FAILURE_ADYEN_BATCHES, { error });

export const FETCH_ADYEN_BATCHES_BY_BATCH_NUMBER = 'FETCH_ADYEN_BATCHES_BY_BATCH_NUMBER';
export const REQUEST_ADYEN_BATCHES_BY_BATCH_NUMBER = 'REQUEST_ADYEN_BATCHES_BY_BATCH_NUMBER';
export const SUCCESS_ADYEN_BATCHES_BY_BATCH_NUMBER = 'SUCCESS_ADYEN_BATCHES_BY_BATCH_NUMBER';
export const FAILURE_ADYEN_BATCHES_BY_BATCH_NUMBER = 'FAILURE_ADYEN_BATCHES_BY_BATCH_NUMBER';

export const fetchAdyenBatchesByBatchNumber = (batchNumber: number) =>
    action(FETCH_ADYEN_BATCHES_BY_BATCH_NUMBER, { batchNumber });
export const requestAdyenBatchesByBatchNumber = () => action(REQUEST_ADYEN_BATCHES_BY_BATCH_NUMBER);
export const requestAdyenBatchesByBatchNumberSuccess = (response: any) =>
    action(SUCCESS_ADYEN_BATCHES_BY_BATCH_NUMBER, { response });
export const requestAdyenBatchesByBatchNumberFailure = (error: any) =>
    action(FAILURE_ADYEN_BATCHES_BY_BATCH_NUMBER, { error });

export const CONFIRM_ADYEN_BATCH = 'CONFIRM_ADYEN_BATCH';
export const REQUEST_CONFIRM_ADYEN_BATCH = 'REQUEST_CONFIRM_ADYEN_BATCH';
export const SUCCESS_CONFIRM_ADYEN_BATCH = 'SUCCESS_CONFIRM_ADYEN_BATCH';
export const FAILURE_CONFIRM_ADYEN_BATCH = 'FAILURE_CONFIRM_ADYEN_BATCH';

export const confirmAdyenBatch = (batchNumber: number, adyenConfirmationRequest: AdyenConfirmationRequest) =>
    action(CONFIRM_ADYEN_BATCH, { batchNumber, adyenConfirmationRequest });
export const requestConfirmAdyenBatch = () => action(REQUEST_CONFIRM_ADYEN_BATCH);
export const requestConfirmAdyenBatchSuccess = (response: any) => action(SUCCESS_CONFIRM_ADYEN_BATCH, { response });
export const requestConfirmAdyenBatchFailure = (error: any) => action(FAILURE_CONFIRM_ADYEN_BATCH, { error });
